// AUTO-GENERATED FILE !! DO NOT EDIT !!

export const ROLES = {
  /**
   * Fortem Asset Management Team
   */
  ASSET_MANAGEMENT: 'asset-management',

  /**
   * AM Team - Editor
   */
  ASSET_MANAGEMENT_CONTRIBUTOR: 'asset-management-contributor',

  /**
   * AM Team - Readonly
   */
  ASSET_MANAGEMENT_VIEWER: 'asset-management-viewer',

  /**
   * Fortem Data Engineer
   */
  DATA_ENGINEER: 'data-engineer',

  /**
   * Fortem Developer Team
   */
  DEVELOPER: 'developer',

  /**
   * Fortem Flow Team
   */
  FLOW: 'flow',

  /**
   * Flow Team - Editor
   */
  FLOW_CONTRIBUTOR: 'flow-contributor',

  /**
   * Flow Team - Readonly
   */
  FLOW_VIEWER: 'flow-viewer',

  /**
   * Fortem Employees
   */
  FORTEM_EMPLOYEE: 'fortem-employee',

  /**
   * Members of the IC Committee
   */
  IC_COMMITTEE: 'ic-committee',

  /**
   * Fortem Management
   */
  MANAGEMENT: 'management',

  /**
   * Fortem Operations Team
   */
  OPERATIONS: 'operations',

  /**
   * Ops Team - Editor
   */
  OPERATIONS_CONTRIBUTOR: 'operations-contributor',

  /**
   * Ops Team - Readonly
   */
  OPERATIONS_VIEWER: 'operations-viewer',

  /**
   * Can access all pages, without special ability to run report
   */
  READ_ONLY_ADMIN: 'read-only-admin',

  /**
   * Test Role
   */
  ROLETEST: 'RoleTest',

  /**
   * Fortem Sales Team
   */
  SALES: 'sales',

  /**
   * Sales Team - Editor
   */
  SALES_CONTRIBUTOR: 'sales-contributor',

  /**
   * Sales Team - Readonly
   */
  SALES_VIEWER: 'sales-viewer',

  /**
   * Fortem Trading Team
   */
  TRADING: 'trading',

  /**
   * Trading Team - Editor
   */
  TRADING_CONTRIBUTOR: 'trading-contributor',

  /**
   * Trading Team - Readonly
   */
  TRADING_VIEWER: 'trading-viewer',
} as const

export type ROLE = (typeof ROLES)[keyof typeof ROLES]
